/* eslint-disable no-param-reassign */
import {
  isEmpty,
} from 'lodash';
import UserApi from 'api/v2/UserApi';
import Vue from 'vue';

const defaultDisplayPreferences = {
  preferences: {
    display: {
      deviceNotifications: {
        agentOutOfDateMetric: { visible: false },
        inactiveMetric: { visible: false },
        uptimeMetric: {
          additionalDisplaySettings: {
            numberOfDaysToShow: 0,
          },
          visible: false,
        },
        withoutPoliciesMetric: { visible: false },
        withoutUsersMetric: { visible: false },
      },
      diskEncryption: { visible: false },
      expiredPasswords: { visible: false },
      fundamentals: { visible: false },
      jcUniversity: { visible: false },
      learningCenter: { visible: false },
      officeHours: { visible: false },
      upcomingPasswordExpiration: { visible: false },
      userLockouts: { visible: false },
      manualGroupMembership: { visible: false },
      mdmCertificateExpirations: { visible: false },
      newOSReleases: { visible: false },
      newUsers: { visible: false },
      userGroupSuggestions: { visible: false },
      reportsReadyForDownload: { visible: false },
      scheduledUserActivations: { visible: false },
      scheduledUserSuspensions: { visible: false },
      scheduledImportErrors: { visible: false },
      consoleStats: {
        totalUsers: { visible: false },
        totalDevices: { visible: false },
        totalGroups: { visible: false },
        totalApplications: { visible: false },
        totalConfigurations: { visible: false },

      },
      userNotifications: {
        usersWithAdminSudoAccess: { visible: false },
        userWithAdminSudoPasswordlessAccess: { visible: false },
        usersWithoutPassword: { visible: false },
        usersWithSambaAccess: { visible: false },
        usersWithoutDevices: { visible: false },
      },
    },
    scheduledUserActivations: {
      numberOfDaysToShow: 0,
    },
    scheduledUserSuspensions: {
      numberOfDaysToShow: 0,
    },
  },
};

const putUserPreferencesData = payload => {
  UserApi.putSelf(payload);
};

function fetchDisplayPreferencesData(context) {
  return UserApi.getUserPreferences()
    .then((resp) => {
      if (!isEmpty(resp)) {
        context.commit('SET_USER_DISPLAYPREF_DATA', { preferences: resp.preferences });
      }
    });
}

function setDisplayPreferencesData(context, preferences) {
  context.commit('SET_USER_DISPLAYPREF_DATA', preferences);
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setHomeWidgetVisibility(context, { widgetType, visible }) {
  context.commit('SET_HOME_WIDGET_VISIBILITY', { widgetType, visible });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setUserStateVisibility(context, { widgetType, visible }) {
  context.commit('SET_USER_STATE_WIDGET_VISIBILITY', { widgetType, visible });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setDeviceNotificationMetricVisibility(context, { widgetType, visible }) {
  context.commit('SET_DEVICE_NOTIFICATION_METRIC_VISIBILITY', { widgetType, visible });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setUserStateDays(context, { widgetType, numberOfDaysToShow }) {
  context.commit('SET_USER_STATE_DAYS', { widgetType, numberOfDaysToShow });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setUpTimeDays(context, { widgetType, numberOfDaysToShow }) {
  context.commit('SET_DEVICE_UPTIME', { widgetType, numberOfDaysToShow });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setConsoleStatsVisibility(context, { widgetType, visible }) {
  context.commit('SET_CONSOLE_STATS_VISIBILITY', { widgetType, visible });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

function setUserNotificationMetricVisibility(context, { widgetType, visible }) {
  context.commit('SET_USER_NOTIFICATION_METRIC_VISIBILITY', { widgetType, visible });
  putUserPreferencesData({ preferences: context.state.displayPreferencesData });
}

// --------------------------------------------------------------------------
// Mutations
// --------------------------------------------------------------------------

function SET_USER_DISPLAYPREF_DATA(state, { preferences }) {
  Vue.set(state, 'displayPreferencesData', preferences);
}

function SET_HOME_WIDGET_VISIBILITY(state, { widgetType, visible }) {
  state.displayPreferencesData.display[widgetType].visible = visible;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_USER_STATE_WIDGET_VISIBILITY(state, { widgetType, visible }) {
  state.displayPreferencesData.display[widgetType].visible = visible;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_DEVICE_NOTIFICATION_METRIC_VISIBILITY(state, { widgetType, visible }) {
  state.displayPreferencesData.display.deviceNotifications[widgetType].visible = visible;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_USER_STATE_DAYS(state, { widgetType, numberOfDaysToShow }) {
  state.displayPreferencesData[widgetType].numberOfDaysToShow = numberOfDaysToShow;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_DEVICE_UPTIME(state, { widgetType, numberOfDaysToShow }) {
  state.displayPreferencesData.display.deviceNotifications[widgetType]
    .additionalDisplaySettings.numberOfDaysToShow = numberOfDaysToShow;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_CONSOLE_STATS_VISIBILITY(state, { widgetType, visible }) {
  state.displayPreferencesData.display.consoleStats[widgetType].visible = visible;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}

function SET_USER_NOTIFICATION_METRIC_VISIBILITY(state, { widgetType, visible }) {
  state.displayPreferencesData.display.userNotifications[widgetType].visible = visible;
  Vue.set(state, 'displayPreferencesData', state.displayPreferencesData);
}
// this is exported so we can create new modules for unit testing
export const createUserDisplayPreferencesModule = () => ({
  namespaced: true,
  state: {
    displayPreferencesData: defaultDisplayPreferences.preferences,
  },
  actions: {
    fetchDisplayPreferencesData,
    setDisplayPreferencesData,
    setHomeWidgetVisibility,
    setDeviceNotificationMetricVisibility,
    setUserStateDays,
    setUserStateVisibility,
    setConsoleStatsVisibility,
    setUserNotificationMetricVisibility,
    setUpTimeDays,
  },
  mutations: {
    SET_USER_DISPLAYPREF_DATA,
    SET_HOME_WIDGET_VISIBILITY,
    SET_DEVICE_NOTIFICATION_METRIC_VISIBILITY,
    SET_USER_STATE_DAYS,
    SET_USER_STATE_WIDGET_VISIBILITY,
    SET_CONSOLE_STATS_VISIBILITY,
    SET_USER_NOTIFICATION_METRIC_VISIBILITY,
    SET_DEVICE_UPTIME,
  },
});

export default createUserDisplayPreferencesModule();
